import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGitlabLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 54,
	height: 54,
	viewBox: "0 0 54 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M26.9985 52.2101L36.9466 21.61H17.0647L26.9985 52.2101Z",
			fill: "#E24329"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.13036 21.61L0.100929 30.9067C-0.17321 31.7509 0.12284 32.6827 0.846411 33.2089L26.9982 52.21L3.13036 21.61Z",
			fill: "#FCA326"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.13062 21.61H17.0646L11.0678 3.18095C10.7609 2.2381 9.42332 2.2381 9.10536 3.18095L3.13062 21.61Z",
			fill: "#E24329"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.8805 21.61L53.899 30.9067C54.1732 31.7509 53.8771 32.6827 53.1535 33.2089L26.9983 52.2101L50.8805 21.61Z",
			fill: "#FCA326"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.8806 21.61H36.9465L42.9323 3.18095C43.2392 2.2381 44.5768 2.2381 44.8948 3.18095L50.8806 21.61Z",
			fill: "#E24329"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.9983 52.2101L36.9464 21.61H50.8805L26.9983 52.2101Z",
			fill: "#FC6D26"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.9984 52.2101L3.13062 21.61H17.0646L26.9984 52.2101Z",
			fill: "#FC6D26"
		})
	]
});
const ForwardRef = forwardRef(SvgGitlabLogo);
export { ForwardRef as ReactComponent };
